import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.7.3l5 5A1 1 0 0115 7h-2.918a8 8 0 002.258 4.51l5.37 5.37a1 1 0 010 1.41l-1.42 1.42a1 1 0 01-1.41 0l-5.37-5.37A11.99 11.99 0 0110 12.492c-.437.66-.942 1.28-1.51 1.848l-5.37 5.37a1 1 0 01-1.41 0L.29 18.29a1 1 0 010-1.41l5.37-5.37A8 8 0 007.92 7H5a1 1 0 01-.7-1.7l5-5a1 1 0 011.4 0z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
